import { DropDownOption } from "../../model/interfaces/drop-down-option.interface";

export const TASK_STATUS_ITEMS: DropDownOption[] = [
    { id: false, displayValue: 'Open' },
    { id: true, displayValue: 'Closed' }
];
